import React from 'react'
import PdaTitle from '../../component/common/PdaTitle'
import LogoDark from '../../component/common/LogoDark'
import { PdaMenuItem } from '../../types/common'
import MenuLink from '../../component/common/MenuLink'
import { tokens } from '../../locales/tokens'
import { useTranslation } from 'react-i18next'

const OutboundMenu = () => {
    const { t } = useTranslation()
    const menus: PdaMenuItem[] = [
        {
            name: '토탈 피킹',
            uri: '/outbound/total-picking',
        },
        {
            name: t(tokens.common.individual_picking),
            uri: '/outbound/piece-picking',
        },
        {
            name: t(tokens.outbound.midmile_outgoing),
            uri: '/outbound/middle-mile',
        },
    ]

    return (
        <>
            <PdaTitle title={t(tokens.outbound.management)} historyBack />
            <LogoDark />
            <MenuLink items={menus} color="bg-color-green border-color-green" />
        </>
    )
}

export default OutboundMenu
